import { Typography } from "best-common-react";
import React from "react";
import { useAdminReporting } from "../../../contexts/ admin/AdminReportingContext";
import { UserViewsByOrg } from "../../../types/Reports";
import AdminReportingForm from "./AdminReportingForm";
import AdminReportingResults from "./AdminReportingResults";

const AdminVideoDownloads = () => {
  const { data } = useAdminReporting();
  return (
    <div className="bcr-p-2">
      <Typography variant="displaySmall">User Video Downloads</Typography>
      <AdminReportingForm />
      <AdminReportingResults data={data as UserViewsByOrg[]} defaultSortKey="viewDate" />
    </div>
  );
};

export default AdminVideoDownloads;
